import { useState, useEffect, useCallback } from 'react'

/**
 * Hook that listens for 'limit-exceeded' custom events dispatched by the API client
 * and manages the open/close state and error data for the UpgradePromptDialog.
 *
 * @returns {{ isOpen: boolean, error: object|null, close: () => void }}
 */
export function useLimitExceededDialog() {
  const [isOpen, setIsOpen] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    const handleLimitExceeded = (event) => {
      setError(event.detail)
      setIsOpen(true)
    }

    window.addEventListener('limit-exceeded', handleLimitExceeded)
    return () => {
      window.removeEventListener('limit-exceeded', handleLimitExceeded)
    }
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
    setError(null)
  }, [])

  return { isOpen, error, close }
}
